import { X, Sparkles } from 'lucide-react';
import { useApp } from '../lib/AppContext';
import Button from './Button';

export default function ReflectionPrompt() {
  const { showReflectionPrompt, reflectionPromptIssue, dismissReflectionPrompt, navigateTo } = useApp();

  if (!showReflectionPrompt || !reflectionPromptIssue) return null;

  const handleAddToMeaningLayer = () => {
    dismissReflectionPrompt();
    navigateTo('profile');
  };

  const handleDismiss = () => {
    dismissReflectionPrompt();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center px-6 animate-fade-in"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="bg-gradient-to-br from-[#181818] to-[#1a1a1a] rounded-xl p-6 w-full max-w-sm border border-[#40E0D0] border-opacity-30 animate-scale-in">
        <Button
          onClick={handleDismiss}
          variant="tertiary"
          className="absolute top-4 right-4 !p-2 !min-h-0 !h-auto"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </Button>

        <div className="flex items-center gap-2 mb-4">
          <Sparkles className="w-6 h-6 text-[#40E0D0] animate-pulse-slow" />
          <h3 className="text-[18px] font-semibold text-[#F5F5F5]">
            Meaning Layer Update
          </h3>
        </div>

        <p className="text-[14px] text-[#F5F5F5] leading-relaxed mb-2">
          You've explored several stories about <span className="font-semibold text-[#40E0D0]">{reflectionPromptIssue}</span> lately.
        </p>

        <p className="text-[13px] text-[#A0A0A0] mb-6">
          This is becoming part of your civic identity map.
        </p>

        <div className="space-y-3">
          <Button fullWidth variant="secondary" onClick={handleAddToMeaningLayer}>
            View my Meaning Layers
          </Button>
          <Button
            onClick={handleDismiss}
            variant="tertiary"
            fullWidth
          >
            Keep exploring
          </Button>
        </div>
      </div>
    </div>
  );
}
